<app-card [className]="'card--summary'">
  <div class="card--summary__inner about">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.about.title' | translate }}</h2>
      </div>
    </div>
    <div class="card__content">
      <div
        class="card--summary__description"
        [appTranslateText]="customer.description"
        [html]="customer.description"
        [language]="language"
      ></div>
      <div class="card--summary__image" *ngIf="customer.logoThumbnails">
        <img [src]="customer.logoThumbnails.medium" alt="Organisation Logo" />
      </div>
    </div>
  </div>
</app-card>

<app-card [className]="'card--summary'">
  <div class="card--summary__inner">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.contact.title' | translate }}</h2>
      </div>
    </div>
    <div class="card--summary__body">
      <div>
        <div>
          <span *ngIf="customer.street">
            {{ customer.street }}
          </span>
          <span *ngIf="customer.streetNumber">
            {{ customer.streetNumber }}
          </span>
        </div>
        <div>
          <span *ngIf="customer.zipcode">
            {{ customer.zipcode }}
          </span>
          <span *ngIf="customer.city">
            {{ customer.city }}
          </span>
        </div>
      </div>
      <ng-container *ngIf="customer.phoneNumber">
        <a [href]="'tel:' + customer.phoneNumber" class="card--summary__phone">
          <div
            class="inline-svg contact-info__phone-number__icon"
            [attr.aria-label]="'contact-info.phone' | translate"
          >
            <span aria-hidden="true" inlineSVG="assets/icons/phone.svg"></span>
          </div>
          {{ customer.phoneNumber }}
        </a>
      </ng-container>
    </div>
    <div class="card__content"></div>
  </div>
</app-card>
